/**
 * Початкові значення нового запису з подання (прототип v4: «+» колонки дошки створює запис у цій колонці): подання задає їх перед
 * відкриттям діалогу створення, кнопка «+ Створити» панелі — скидає. Живе в пам'яті сторінки; підписники дізнаються про зміну одразу.
 */
type Preset = Readonly<Record<string, string>> | null;

let current: Preset = null;
const listeners = new Set<() => void>();

export const newRecordPreset = {
  get: (): Preset => current,
  set: (next: Preset): void => {
    current = next;
    listeners.forEach((l) => l());
  },
  subscribe: (listener: () => void): (() => void) => {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
  },
};
